/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class InputAdvancedPanel extends React.Component {
	render() {
		let constants = this.props.app.config.constants,
			preferSummary = this.props.input.preferSummary, // default is set in InputDefaultsModule
			useDateFlag = (this.props.input.useDateFlag) ? true : false,
			postImages = (this.props.input.postImages) ? true : false,
			mediaOrder = (this.props.input.mediaOrder) ? this.props.input.mediaOrder : constants.MEDIA_OG_FIRST,
			ignoreOrigLink = (this.props.input.ignoreOrigLink) ? true : false,
			skipNoTitle = (this.props.input.skipNoTitleFlag) ? true : false,
			ignoreSortDate = (this.props.input.ignoreSortDate) ? true : false,
			postImageField = null,
			excludeReplies = (this.props.input.attrs && parseInt(this.props.input.attrs.exclude_replies, 10)) ? true : false,
			includeRetweets = (this.props.input.attrs && parseInt(this.props.input.attrs.include_rts, 10)) ? true : false,
			excludeRepliesControl = null,
			includeRetweetsControl = null,
			mediaOrderField = null,
			republishField = null,
			feedburnerLinksField = null,
			ignoreItemsWithNoTitleField = null,
			ignoreSortDateField = null,
			bodyPostingOptions = null;

		if (preferSummary === null || preferSummary === undefined) {
			preferSummary = 0;
		}

		// September 2023 - We're hiding the 'Enable Photo Posting' toggle for simple accounts when it's turned
		// on. To keep it from flashing off immediately look up the original value in the route list and compare
		// the values
		if ((this.props.user.detail.routeViewType === constants.ROUTE_VIEW_ADVANCED || (this.props.cleanInput && !this.props.cleanInput.postImages)) &&
			[
				constants.INPUT_TYPE_INSTAGRAM,
				constants.INPUT_TYPE_INSTAGRAM_BUSINESS,
				constants.INPUT_TYPE_PINTEREST
			].indexOf(this.props.input.type) === -1
		) {
			postImageField = (
				<fieldset>
					<legend>Enable Photo Posting<HelpButton which="postImagesInput"/></legend>
					<Toggle active={postImages}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".postImages"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />
				</fieldset>
			);
		}

		if (this.props.input.type == constants.INPUT_TYPE_TWITTER) {
			excludeRepliesControl = (
				<fieldset>
					<legend>Exclude Replies</legend>
					<Toggle active={excludeReplies}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".attrs.exclude_replies"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />
				</fieldset>
			);
			includeRetweetsControl = (
				<fieldset>
					<legend>Include Retweets</legend>
					<Toggle active={includeRetweets}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".attrs.include_rts"}
							labelPlacement="right"
							labelClass="advanced-toggle-label"/>
				</fieldset>
			);
		}

		if (this.props.input.type == constants.INPUT_TYPE_FEED) {
			bodyPostingOptions = (
				<fieldset>
					<legend>Body Posting Options <HelpButton which="preferSummary"/></legend>
					<StyledSelect options={[{value:1, label: 'Prefer Summary Content'}, {value:0, label: 'Prefer Full Content'}]}
									linkedField={this.props.statePath + ".preferSummary"}
									onChange={this.props.changeHandler}
									value={preferSummary}
									selectClass="large" />
				</fieldset>
			);
			mediaOrderField = (
				<fieldset>
					<legend>Image Selection Order</legend>
						<StyledSelect options={[{value:0, label: 'Open Graph Tags First'}, {value:1, label: 'Feed Content First'}]}
							linkedField={this.props.statePath + ".mediaOrder"}
							onChange={this.props.changeHandler}
							value={mediaOrder}
							selectClass="large" />
				</fieldset>
			);
			republishField = (
				<fieldset>
					<legend>Republish items with updated timestamps<HelpButton which="useDateFlag"/></legend>
					<Toggle active={useDateFlag}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".useDateFlag"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />

				</fieldset>
			);
			feedburnerLinksField = (
				<fieldset>
					<legend>Pass Feedburner links to your link shortening service<HelpButton which="ignoreOrigLink"/></legend>
					<Toggle active={ignoreOrigLink}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".ignoreOrigLink"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />
				</fieldset>
			);
			ignoreItemsWithNoTitleField = (
				<fieldset>
					<legend>Ignore feed items with no title</legend>
					<Toggle active={skipNoTitle}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".skipNoTitleFlag"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />
				</fieldset>
			);
			ignoreSortDateField = (
				<fieldset>
					<legend>Do not sort feed by item timestamps</legend>
					<Toggle active={ignoreSortDate}
							activeLabel="On"
							inactiveLabel="Off"
							callback={this.props.changeHandler}
							linkedField={this.props.statePath + ".ignoreSortDate"}
							labelPlacement="right"
							labelClass="advanced-toggle-label" />
				</fieldset>
			);
		}

		return (
			<div className="editor-panel">
				<form>
					{bodyPostingOptions}
					{excludeRepliesControl}
					{includeRetweetsControl}
					{republishField}
					{postImageField}
					{mediaOrderField}
					{feedburnerLinksField}
					{ignoreItemsWithNoTitleField}
					{ignoreSortDateField}
				</form>
			</div>
		);
	}
};

InputAdvancedPanel.displayName = "InputAdvancedPanel";

export default ComponentWithContext(InputAdvancedPanel);
